import Spreadsheet from '@/Spreadsheet';

class ValidationError extends Error {
  constructor(message, id) {
    super(message);

    this.id = id;
  }
}

const validateSheetTitles = async (spreadsheet, titles) => {
  for (let i = 0; i < titles.length; i++) {
    const sheetId = await spreadsheet.getSheetIdFor(titles[i]);

    if (sheetId == undefined) {
      throw new ValidationError(
        `The spreadsheet must have a sheet named "${titles[i]}".`,
        spreadsheet.id
      );
    }
  }
};

const validateSheetHeader = async (spreadsheet, sheet, titles) => {
  const range = await spreadsheet.readRange(`${sheet}!1:1`);

  if (range == undefined) {
    throw new Error(`The first row of "${sheet}" sheet must contain header.`);
  }

  const [cols] = range;

  for (let i = 0; i < titles.length; i++) {
    if (
      typeof cols[i] != 'string' ||
      cols[i].toLowerCase() != titles[i].toLowerCase()
    ) {
      throw new ValidationError(
        `The "${sheet}" sheet must have a header named "${
          titles[i]
        }" on column ${String.fromCharCode(65 + i)}.`,
        spreadsheet.id
      );
    }
  }
};

const validateHasAtLeastOnOption = async (spreadsheet, sheet, column) => {
  const [rows] = await spreadsheet.readRange(`${sheet}!${column}:${column}`, {
    majorDimension: 'COLUMNS',
  });

  const title = rows.shift();

  const items = rows.filter(Boolean);

  if (items.length == 0) {
    throw new ValidationError(
      `The "${title}" column on "${sheet}" sheet must have at least one option.`,
      spreadsheet.id
    );
  }
};

const validateBalanceSheet = async id => {
  const spreadsheet = new Spreadsheet(id);

  try {
    await spreadsheet.getDetail();
  } catch (error) {
    throw new Error('Unable to load the spreadsheet.');
  }

  await Promise.all([
    validateSheetTitles(spreadsheet, [
      'Expenses',
      'Investments',
      'Income',
      'Expense Categories',
      'Options',
    ]),

    validateSheetHeader(spreadsheet, 'Expenses', [
      'Date',
      'Item',
      'Amount',
      'Category',
      'Subcategory',
      'Payment Method',
      'Merchant',
      'Merchant Type',
      'Description',
    ]),

    validateSheetHeader(spreadsheet, 'Investments', [
      'Date',
      'Product',
      'Type',
      'Amount',
      'Via',
      'Description',
    ]),

    validateSheetHeader(spreadsheet, 'Income', [
      'Date',
      'Amount',
      'Source',
      'Description',
    ]),

    validateSheetHeader(spreadsheet, 'Expense Categories', [
      'Categories',
      'Subcategories',
    ]),

    validateSheetHeader(spreadsheet, 'Options', [
      'Expense Payment Methods',
      'Expense Merchant Types',
      'Investment Types',
      'Investment Via',
      'Income Sources',
    ]),

    validateHasAtLeastOnOption(spreadsheet, 'Expense Categories', 'A'),

    validateHasAtLeastOnOption(spreadsheet, 'Options', 'C'),

    validateHasAtLeastOnOption(spreadsheet, 'Options', 'E'),
  ]);

  return spreadsheet;
};

export default validateBalanceSheet;
